import Styles from "./Subscription.scss";
import { connect } from "react-redux";
import Icon from "@mdi/react";
import { mdiLoading } from "@mdi/js";
import SubscriptionInfo from "./SubscriptionInfo";
import React, { useState } from "react";
import SubscriptionProduct from "./SubscriptionProduct";
import SubscriptionInvoices from "./SubscriptionInvoices";
const Subscription = ({ props }) => {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <div
            className={
                "d-flex flex-column justify-content-start align-items-center text-dark w-100"
            }
            style={{ backgroundColor: "#F1F4F4" }}
        >
            <div className="d-flex flex-column flex-lg-row justify-content-start align-items-start w-100">
                <div className="d-flex col col-lg-8 h-100">
                    <SubscriptionProduct />
                </div>
                <div className="d-flex col col-lg-4 mt-4 mt-lg-0">
                    <SubscriptionInfo />
                </div>
            </div>
            <div className="d-flex col h-100 mt-4">
                <SubscriptionInvoices />
            </div>

            {/*(isLoading)?
                                <div className="row vh-100">
                                    <div className="col-12 justify-content-center align-items-center">
                                        <div className="text-center my-2 "><Spinner animation="border" size={'sm'}/></div>
                                    </div>
                                </div>
                                :<div className={"w-100"}>
                                    <div className="form-row">
                                        <div className="form-group col-12">
                                            <label htmlFor="subscription_label" className={"col-form-label ue-col-form-label"}>Forfait</label>
                                            <input type="text" className="form-control ue-form-control" id="subscription_label" name="subscription_label" ref={register}
                                                   readOnly
                                                   defaultValue={(entity?.subscription?.label)?entity.subscription.label:''}/>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-12">
                                            <label htmlFor="subscription_duration" className={"col-form-label ue-col-form-label"}>Durée du contrat</label>
                                            <input type="text" className="form-control ue-form-control" id="subscription_duration" name="subscription_duration" ref={register}
                                                   readOnly
                                                   defaultValue={(entity?.subscription?.duration)?entity.subscription.duration:''}/>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-12 col-md-6">
                                            <label htmlFor="subscription_start_at" className={"col-form-label ue-col-form-label"}>Date de début</label>
                                            <input type="text" className="form-control ue-form-control" id="subscription_start_at" name="subscription_start_at" ref={register}
                                                   readOnly
                                                   defaultValue={(entity?.subscription?.start_at)?entity.subscription.start_at:''}/>
                                        </div>
                                        <div className="form-group col-12 col-md-6">
                                            <label htmlFor="subscription_end_at" className={"col-form-label ue-col-form-label"}>Date de renouvellement</label>
                                            <input type="text" className="form-control ue-form-control" id="subscription_end_at" name="subscription_end_at" ref={register}
                                                   readOnly
                                                   defaultValue={(entity?.subscription?.end_at)?entity.subscription.end_at:''}/>
                                        </div>
                                    </div>

                                </div>
                     */}
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        userId: state.MeReducer.id,
        username: state.MeReducer.username,
        role: state.MeReducer.role,
        structureInfo: state.SubscribtionReducer.structureInfo,
        entity: state.MeReducer.entity,
        currentSubscriptions: state.MeReducer.currentSubscription,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        updateUserInfo: (e) =>
            dispatch({ type: "UPDATE_USER_STATUS", data: e }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(Subscription);
